import {Component, Input, OnInit} from '@angular/core';

import {ActivatedRoute} from '@angular/router';

import {
  ClientProfileService,
} from '../../_services/index';

import {MatDialog} from '@angular/material/dialog';
import {Role} from "../../helpers";
import {Constants} from "../../helpers/constants";
import {MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {WorkstreamItemComponent} from "../workstreamItem";
import {WorkstreamService} from "../../_services/workstream.service";
import {ConfirmComponent} from "../confirm";
import {WorkstreamComponent} from "../workstream/workstream.component";
import {UploadComplianceAreaComponent} from "../uploadComplianceArea";
import {WorkstreamUploadComponent} from "../workstreamUpload";
import {
  AddLinkRecommendedSolutionComponent
} from "../addLinkRecommendedSolution/add-link-recommended-solution.component";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {RecommendedSolutionsListComponent} from "../recommendedSolutionsList";
import {ReferenceResourceService} from "../../_services/referemceResource.service";
import {AddLinkReferenceResourceComponent} from "../addLinkRefrenceResource/add-link-reference-resource.component";
import {ReferenceResourcesListComponent} from "../referenceResourcesList";
import {ReferenceResourceUploadComponent} from "../referenceResourceUpload";

@Component({
    standalone: false,
  selector: "reference-resources",
  templateUrl: 'reference-resources.component.html',
  styleUrls: ['./reference-resources.component.scss'],
})

export class ReferenceResourcesComponent implements OnInit {

  items: any[] = [];
  rowGroupIndexes: any[] = [];
  currentUser: any;
  public dialogRef: MatDialogRef<any, any>;
  cols : any[] = [
    {'field': 'name', 'header': 'Name'},
    {'field': 'url', 'header': 'URL', 'fn': function(val) { return '<a href="' + val + '">' + val + '</a>'; }},
    {'field': 'sourceProvider', 'header': 'Source/Provider'},
    {'field': 'notes', 'header': 'Notes'}
  ]
  exportCols;

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public service: ReferenceResourceService) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.exportCols = [{header: 'List', field: 'listName'}].concat(this.cols);
  }

  ngOnInit() {
    this.service.getAll().subscribe(result => {
      this.items = [];
      let i = 0;
      for (let list of result) {
        this.rowGroupIndexes[list.referenceResourcesListId] = i;
        if (!list.referenceResources.length) {
          this.items.push({listId: list.referenceResourcesListId, listName: list.name, 'virtual': true});
          i++;
        } else {
          for (let item of list.referenceResources) {
            item.listName = list.name;
            this.items.push(item);
            i++;
          }
        }
      }
    });
  }

  editItem(item: any) {
    this.edit(AddLinkReferenceResourceComponent, item);
  }

  createList() {
    this.edit(ReferenceResourcesListComponent, {
      name: ""
    });
  }

  createItem(listId) {
    this.edit(AddLinkReferenceResourceComponent, {
      listId: listId
    })
  }

  editList(item: any) {
    this.edit(ReferenceResourcesListComponent, {
      referenceResourcesListId: item.listId,
      name: item.listName
    });
  }

  public edit(component, item: any) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        entity: item
      }
    };

    this.dialogRef = this.dialog.open(component, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.value) {
        result.value.date = new Date();
        result.value.submitterId = this.currentUser.userId;
        this.service.saveReferenceResource(result.value).subscribe(() => {
          this.ngOnInit();
        })
      } else {
        this.ngOnInit();
      }
    });
  }

  public deleteItem(itemId) {
    this.delete('Reference Resource', (id) => this.doDeleteItem(id), itemId);
  }

  public deleteList(listId) {
    this.delete('Reference Resources List', (id) => this.doDeleteList(id), listId);
  }

  public delete(name, callback, item) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Do you want to delete this ' + name + '?',
        yes: 'Yes',
        no: 'No',
        confirm: () => callback(item),
        cancel: () => {
        }
      }
    });
  }

  public doDeleteItem(itemId) {
    this.service.deleteReferenceResource(itemId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  public doDeleteList(listId) {
    this.service.deleteList(listId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    if (this.currentUser.role == Role.KingAdmin) {
      return Constants.RiskSpongeMaster;
    }

    return this.currentUser.tenantName;
  }

  importReferenceResources() {
    const dialogRef = this.dialog.open(ReferenceResourceUploadComponent, {});

    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }
}
